import { BridgeClient } from 'app/service/bridge/BridgeClient';
import { createMerchandisingApi } from './merchandisingApi';

export function createBridgeMerchandisingApi({ client = new BridgeClient() } = {}) {
  return createMerchandisingApi({
    send: (action, payload, timeout) =>
      client.sendMessageWithResponse(action, payload, timeout),
  });
}
